// extracted by mini-css-extract-plugin
export default {"menuRoot":"SidebarPanelMenuBase_menuRoot__4rTK4","menuLinkActiveItem":"SidebarPanelMenuBase_menuLinkActiveItem__-g2++"};